import Vue from 'vue'
import Vuex from 'vuex'
import Auth from '@/service/Auth';
import User from '@/service/User';

import analysisStore from '@/store/analysis.store.js'
import gaEventTypesStore from '@/store/gaEventTypes.store.js'

Vue.use(Vuex)
const AuthService = new Auth()
const UserService = new User()

export default new Vuex.Store({
    modules: {
        analysisStore,
        gaEventTypesStore,
        user: {
            state: {
                loggedIn: AuthService.getToken(),
                info: {
                    subscription: {
                        plan: {}
                    }
                },
                hasGoogleConnection: null,
            },

            actions: {
                async getUserInfo ({ commit }) {
                    const user = await UserService.get()
                    commit('setUserInfo', user)
                    commit('setGoogleConnection', user.has_google_connection)
                    return user
                },
            },

            mutations: {
                setUserInfo (state, user) {
                    state.info = user
                },

                setPermissions (state, permissions) {
                    state.permissions = { ...permissions }
                },

                setGoogleConnection (state, data) {
                    state.hasGoogleConnection = data
                }
            },

            getters: {
                currentUser(state) {
                    return state
                },

                userInfo(state) {
                    return state.info
                },

                permissions(state) {
                    return state.info.permissions
                },

                plan(state) {
                    return state.info.subscription.plan
                },

                checkPermissions: state => permission => {
                    if (!state.info.permissions) {
                        return
                    }
                    return !!Object.values(state.info.permissions).find(el => el.slug === permission)
                },

                checkSpecificPermission: state => (permission, permissionableId) => {
                    return !!state.info.specificPermissions.find(p => p.permissionable_id === permissionableId && p.permission.slug === permission)
                },

                subUsers(state) {
                    return state.info.subUsers
                },

                getGoogleConnection(state) {
                    return state.hasGoogleConnection
                },
            },
        },

        billing: {
            state: {
                planId: '',
                method: '',
                country: [],
                planApplying: '',
                planApplyingOptions: [],
                houseNumber: '',
                noTax: false,
                address: [],
            },

            mutations: {
                setPlanId (state, data) {
                    state.planId = data
                },

                setPlanMethod (state, data) {
                    state.method = data
                },

                setPlanApplying (state, data) {
                    state.planApplying = data
                },

                setBillingAddress (state, data) {
                    state.address = data
                },

                setHouseNumber (state, data) {
                    state.houseNumber = data
                },

                setNoTax (state, data) {
                    state.noTax = data
                },

                setCountry (state, data) {
                    state.country = data
                },

                setPlanApplyingOptions (state, data) {
                    state.planApplyingOptions = data
                }
            },

            getters: {
                getBillingInfo(state) {
                    return state
                },
            },
        }
    },
})
